export default __webpack_public_path__ + "static/media/aaa.0f718bcb.png";